import React from "react";
import PropTypes from "prop-types";
import Form from "./Form";
import { Wrapper } from "../styles/competencies-styles";

const Competencies = ({
  cardData,
  closeActionModalAfterSubmit,
  fetchKanbanData,
  handleCancelRecruiterConfirmation,
}) => {
  const handleCancel = (e) => {
    e.preventDefault();
    handleCancelRecruiterConfirmation(e);
  };

  const { candidate } = cardData;

  return (
    <Wrapper>
      <Form
        candidate={candidate}
        handleCancel={handleCancel}
        closeActionModalAfterSubmit={closeActionModalAfterSubmit}
        fetchKanbanData={fetchKanbanData}
        cardData={cardData}
      />
    </Wrapper>
  );
};

Competencies.propTypes = {
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    updateStatusLink: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
};

export default Competencies;
